import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../../contexts/AppContext';
import APIList from '../../../../http/ApiList';

import { Button, Input } from 'antd';

const InputContainer: React.FC<any> = (props) => {
  const { authInfo, globalEvent, setGlobalEvent } = useContext(AppContext);
  const { property } = props;
  const [inputValue, setInputValue] = useState<any>(property.value);

  const getChatData = (event: any) => {};
  const valeChange = () => {
    const eventInfo = {
      eventType: property.eventName,
      data: { title: property.title, value: inputValue },
    };
    setGlobalEvent(eventInfo);
  };

  useEffect(() => {
    if (!globalEvent) {
      return;
    }
    if (
      property.dataSource &&
      property.dataSource.triggerEvent &&
      property.dataSource.triggerEvent.find((triggerEvent) => {
        return triggerEvent.event === globalEvent.eventType;
      })
    ) {
      getChatData(globalEvent);
    }
  }, [globalEvent]);
  useEffect(() => {}, []);

  return (
    <>
      <div className="input-container">
        <div className="title-area">{property.title}</div>
        <div className="context-area">
          <div className="label">{property.label}</div>
          <div className="input">
            <Input defaultValue={property.defaultValue} style={{ width: property.inputWidth ?? '120px' }} value={inputValue}></Input>
          </div>
          <div className="percent">{property.unit}</div>
          {property.buttonName ? <Button onClick={valeChange}>{property.buttonName}</Button> : <></>}
        </div>
      </div>
    </>
  );
};

export default InputContainer;
